import { Coins } from "lucide-react";
import { useDisplayCurrency, useSetDisplayCurrency } from "@/domain/hooks";
import type { Currency } from "@/domain/types";
import { cn } from "@/design/cn";

const OPTIONS: Currency[] = ["UGX", "EUR"];

/**
 * Compact display-currency toggle (spec §2.6). Flips every routed figure between
 * the field currency (UGX) and the funder currency (EUR) via the FX converter.
 */
export function CurrencyToggle() {
  const current = useDisplayCurrency();
  const setCurrency = useSetDisplayCurrency();
  return (
    <div
      className="flex items-center gap-0.5 rounded-md border border-line bg-subtle/60 p-0.5"
      role="group"
      aria-label="Display currency"
    >
      <Coins className="ml-1 mr-0.5 h-3.5 w-3.5 text-faint" aria-hidden />
      {OPTIONS.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => setCurrency(c)}
          aria-pressed={current === c}
          className={cn(
            "rounded px-2 py-1 text-xs font-medium tabular-nums transition-colors",
            current === c ? "bg-card text-ink shadow-sm" : "text-mute hover:text-ink",
          )}
        >
          {c}
        </button>
      ))}
    </div>
  );
}
